import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Lock } from '@mui/icons-material';

interface AccessDeniedModalProps {
  open: boolean;
  onClose: () => void;
  pageName: string;
}

export const AccessDeniedModal: React.FC<AccessDeniedModalProps> = ({
  open,
  onClose,
  pageName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          textAlign: 'center',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: '#FEE2E2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Lock sx={{ fontSize: 32, color: '#DC2626' }} />
        </Box>
      </Box>

      <DialogTitle sx={{ pt: 2, fontWeight: 700, fontSize: 20 }}>
        Access Denied
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', color: '#64748B' }}>
          You don't have permission to access the{' '}
          <Typography component="span" fontWeight={600} color="#0F172A">
            {pageName}
          </Typography>{' '}
          page.
          <br />
          <br />
          This page is restricted to{' '}
          <Typography component="span" fontWeight={600} color="#0F172A">
            Administrators
          </Typography>{' '}
          only.
          <br />
          <br />
          Please contact your organization's administrator for access.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            bgcolor: '#3B82F6',
            '&:hover': { bgcolor: '#2563EB' },
            textTransform: 'none',
            px: 4,
          }}
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};